import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Chip,
} from "@mui/material";
import { Check, Close } from "@mui/icons-material";
import { SPACING, TRANSITIONS } from "../../theme/constants";

const PlanCard = ({ plan, currentPlan, onUpgrade }) => {
  const isCurrentPlan = currentPlan === plan.name;

  return (
    <Card
      sx={{
        mx: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        transition: TRANSITIONS.default,
        border: plan.popular ? "2px solid" : "1px solid",
        borderColor: plan.popular ? "primary.main" : "divider",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: 6,
        },
      }}
    >
      {plan.popular && (
        <Chip
          label="Most Popular"
          color="primary"
          size="small"
          sx={{
            position: "absolute",
            top: SPACING.sm,
            right: SPACING.sm,
            fontWeight: 600,
          }}
        />
      )}

      <CardContent sx={{ flexGrow: 1, pt: 4 }}>
        {/* Plan Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: `${plan.color}20`,
              color: plan.color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {plan.icon}
          </Box>
          <Typography variant="h5" fontWeight={700}>
            {plan.name}
          </Typography>
        </Box>

        {/* Price */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
            <Typography variant="h3" fontWeight={700}>
              ${plan.price}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              /month
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary">
            {plan.billingLabel || "Billed monthly"}
          </Typography>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Features */}
        <List sx={{ py: 0 }}>
          {plan.features.map((feature, index) => (
            <ListItem key={index} sx={{ px: 0, py: 1 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                {feature.included ? (
                  <Check sx={{ color: "success.main", fontSize: 20 }} />
                ) : (
                  <Close sx={{ color: "text.disabled", fontSize: 20 }} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={feature.text}
                primaryTypographyProps={{
                  variant: "body2",
                  color: feature.included ? "text.primary" : "text.disabled",
                }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>

      {/* Action Button */}
      <Box sx={{ p: 3, pt: 0 }}>
        <Button
          variant={isCurrentPlan ? "outlined" : "contained"}
          fullWidth
          size="large"
          disabled={isCurrentPlan}
          onClick={() => onUpgrade(plan)}
          sx={{
            bgcolor: plan.popular && !isCurrentPlan ? plan.color : undefined,
            "&:hover": {
              bgcolor: plan.popular && !isCurrentPlan ? plan.color : undefined,
            },
          }}
        >
          {isCurrentPlan ? "Current Plan" : "Upgrade Now"}
        </Button>
      </Box>
    </Card>
  );
};

export default PlanCard;
